(() => {
  'use strict';
  if (window.CarturioSmartSearch) return;

  const exactCorrections = Object.freeze({
    perffum: 'perfume', perffumm: 'perfume', perfum: 'perfume', perfumm: 'perfume',
    parffum: 'perfume', parfume: 'perfume', perphume: 'perfume', perrfume: 'perfume',
    perfuem: 'perfume', perfmue: 'perfume', perume: 'perfume',
    lipstik: 'lipstick', lipstic: 'lipstick', lipstck: 'lipstick',
    botle: 'bottle', bottel: 'bottle', bottlee: 'bottle',
    shampu: 'shampoo', shampo: 'shampoo',
    blutooth: 'bluetooth', bluetooh: 'bluetooth', bluetoth: 'bluetooth',
    speker: 'speaker', spiker: 'speaker',
    choper: 'chopper', choppper: 'chopper',
    pealer: 'peeler',
    clener: 'cleaner', cleener: 'cleaner', cleanr: 'cleaner',
    disspenser: 'dispenser', dispensor: 'dispenser', dispenSer: 'dispenser',
    moskito: 'mosquito', mosqito: 'mosquito',
    shose: 'shoes', shoose: 'shoes', shooes: 'shoes',
    notebok: 'notebook', notbook: 'notebook',
    orgnizer: 'organizer', organizor: 'organizer', organzier: 'organizer',
    jewlery: 'jewellery', jewelery: 'jewellery',
    masager: 'massager', massanger: 'massager',
    laptp: 'laptop', labtop: 'laptop',
    keybord: 'keyboard', keybaord: 'keyboard',
    wacth: 'watch', waatch: 'watch',
    mosquto: 'mosquito', blutooth: 'bluetooth',
    chopticks: 'chopsticks', chopstiks: 'chopsticks',
    tumbler: 'tumbler', fragnance: 'perfume', fragrence: 'perfume'
  });

  const semanticCorrections = Object.freeze({
    fragrance: 'perfume', fragrances: 'perfume', scent: 'perfume', scents: 'perfume',
    cologne: 'perfume', colognes: 'perfume', attar: 'perfume', parfum: 'perfume',
    organiser: 'organizer', organisers: 'organizers',
    cellphone: 'phone', mobilephone: 'phone'
  });

  const vocabulary = [
    'perfume','perfumes','makeup','lipstick','mascara','brush','shampoo','skincare','beauty',
    'cleaner','cleaning','kitchen','chopper','peeler','oil','sprayer','dispenser','bottle','mug',
    'tumbler','shaker','bag','backpack','shoe','shoes','sneaker','sneakers','toy','toys','lamp',
    'charger','mobile','phone','laptop','keyboard','mouse','fitness','gym','water','storage',
    'organizer','organizers','notebook','stationery','pen','watch','watches','pet','pets','dog',
    'cat','garden','gardening','plant','soap','car','automotive','spray','massager','speaker',
    'bluetooth','pillow','iron','steamer','lint','roller','mop','pan','spoon','chopsticks',
    'container','containers','rack','foldable','clothes','vacuum','wallet','bracelet','jewellery',
    'jewelry','earrings','ring','necklace','detergent','glue','repair','clock','alarm','pest',
    'mosquito','trolley','apron','stain','fragrance','cologne','deodorant','face','cream','serum',
    'foot','mask','holder','stand','fidget','tablet','projector','headrest','hooks','knife',
    'scissors','lunchbox','lunch','sink','faucet','shelf','mat','mats','organise','organize',
    'frying','strainer','scale','spatula','cooking','olive','sports','sipper','headphones',
    'earbuds','handgrip','grip','puzzle','coloring','kids','baby','children','fashion','clothing',
    'trackpants','socks','travel','hair','straightener','handheld','portable','electric','electronic',
    'digital','home','office','computer','accessories','carcare','rust','remover','polish','marble',
    'fabric','screen','spectacle','lens','chain','coolant','bicycle','bike','motorcycle','clean',
    'fresh','crossbody','sling','waterproof','adhesive','scissors','storage','book','cover','shoe',
    'rack','massage','holder','organizer','spider','headrest','prayer','beads','trolley','sponge',
    'apron','chopsticks','knife','jewellery','perfume','perfumes'
  ];
  const words = new Set(vocabulary);
  const intentWords = new Set([
    'i','im','ive','id','me','my','please','pls','want','wanna','need','buy','buying','get',
    'find','search','show','give','looking','look','can','could','would','you','to','a','an',
    'the','some','any','product','products','item','items','something','thing','things','help',
    'hello','hey','bro'
  ]);

  function editDistance(a, b) {
    const rows = a.length + 1;
    const cols = b.length + 1;
    const d = Array.from({length: rows}, () => new Array(cols).fill(0));
    for (let i = 0; i < rows; i++) d[i][0] = i;
    for (let j = 0; j < cols; j++) d[0][j] = j;
    for (let i = 1; i < rows; i++) {
      for (let j = 1; j < cols; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + cost);
        }
      }
    }
    return d[a.length][b.length];
  }

  function correctWord(raw) {
    const word = raw.toLowerCase();
    if (exactCorrections[word]) return exactCorrections[word];
    if (semanticCorrections[word]) return semanticCorrections[word];
    if (words.has(word) || word.length < 5 || !/^[a-z]+$/.test(word)) return word;

    const maxDistance = word.length >= 8 ? 2 : 1;
    let bestDistance = Infinity;
    let best = [];
    for (const candidate of words) {
      if (Math.abs(candidate.length - word.length) > maxDistance) continue;
      const distance = editDistance(word, candidate);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = [candidate];
      } else if (distance === bestDistance) {
        best.push(candidate);
      }
    }
    if (bestDistance <= maxDistance && best.length === 1) return best[0];
    return word;
  }

  function analyze(raw) {
    const original = String(raw || '').trim();
    const tokens = original.match(/[a-z0-9]+/gi) || [];
    if (!tokens.length) return { original, query: original, changed: false };
    const output = [];
    let changed = false;
    for (const rawToken of tokens) {
      const lower = rawToken.toLowerCase();
      const corrected = correctWord(lower);
      if (corrected !== lower) changed = true;
      if (intentWords.has(corrected) && tokens.length > 1) {
        changed = true;
        continue;
      }
      output.push(corrected);
    }
    const query = output.join(' ').trim() || original;
    return { original, query, changed: changed && query.toLowerCase() !== original.toLowerCase() };
  }

  function shuffleFallback(scope) {
    const root = scope || document;
    root.querySelectorAll('.carturio-search-fallback__grid').forEach((grid) => {
      const items = Array.from(grid.children);
      for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [items[i], items[j]] = [items[j], items[i]];
      }
      items.forEach((item, index) => { item.hidden = index >= 4; });
    });
  }

  window.CarturioSmartSearch = { analyze, shuffleFallback };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[role="search"], form[action*="/search"]')) return;
    const input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;
    const result = analyze(input.value);
    if (result.changed && result.query) input.value = result.query;
  }, true);

  document.addEventListener('DOMContentLoaded', () => shuffleFallback(document));
})();